import React, { useEffect, useState } from "react";
import { clientApi } from "../lib/api";
import { Folder, ExternalLink, FolderOpen } from "lucide-react";

export default function Arquivo() {
  const [folders, setFolders] = useState([]);

  useEffect(() => {
    clientApi.get("/archive").then(({ data }) => setFolders(data)).catch(() => setFolders([]));
  }, []);

  return (
    <div className="space-y-6" data-testid="cliente-arquivo-page">
      <div>
        <div className="text-xs uppercase tracking-widest text-accent-orange mb-1">Repositório</div>
        <h1 className="font-display text-3xl md:text-4xl">Arquivo de Entregas</h1>
        <p className="text-sm text-neutral-400 mt-2">Acesso direto às pastas do servidor da agência com todo material entregue ao longo da parceria.</p>
      </div>

      <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-4">
        {folders.map((f) => (
          <a
            key={f.id}
            href={f.url || "#"}
            target={f.url ? "_blank" : undefined}
            rel="noopener noreferrer"
            className="group border border-white/10 rounded-xl p-5 hover:border-accent-orange hover:bg-white/[0.03] transition"
            data-testid={`archive-folder-${f.id}`}
          >
            <div className="flex justify-between items-start mb-3">
              <div className="w-10 h-10 rounded-lg bg-accent-orange/20 flex items-center justify-center text-accent-orange group-hover:bg-accent-orange group-hover:text-black transition">
                <Folder className="w-5 h-5 group-hover:hidden" />
                <FolderOpen className="w-5 h-5 hidden group-hover:block" />
              </div>
              <ExternalLink className="w-4 h-4 text-neutral-500 group-hover:text-accent-orange transition" />
            </div>
            <div className="font-display text-lg leading-tight">{f.name}</div>
            {f.category && <div className="text-[10px] uppercase tracking-widest text-neutral-500 mt-1">{f.category}</div>}
            {f.description && <div className="text-xs text-neutral-400 mt-3 line-clamp-2">{f.description}</div>}
          </a>
        ))}
        {folders.length === 0 && (
          <div className="col-span-full text-sm text-neutral-500 border border-dashed border-white/10 rounded-xl p-10 text-center">
            Nenhuma pasta cadastrada. O admin cria em <span className="text-accent-orange">/admin/client-archive</span>.
          </div>
        )}
      </div>
    </div>
  );
}
